import { TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { useState } from 'react';

const LoginInput = ({
  label,
  type = 'text',
  value,
  onChange,
  error = false,
}: TextFieldProps) => {
  const [wasFocused, setWasFocused] = useState(false);

  const handleFocus = () => {
    setWasFocused(true);
  };

  const isLongLabel = typeof label === 'string' ? label.length >= 20 : null;
  return (
    <TextField
      label={label}
      variant="outlined"
      type={type}
      value={value}
      onChange={onChange}
      error={wasFocused && error}
      onBlur={handleFocus}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '16px',
          borderRadius: '8px',
          '& .MuiOutlinedInput-input': {
            padding: '10px 16px',
          },
          '&:hover fieldset': {
            borderColor: '#721FDD',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#721FDD',
          },
          '&:not(.Mui-focused):not(.Mui-error) fieldset': {
            borderColor: '#000000',
          },
          '&.Mui-error fieldset': {
            borderColor: '#FF0000',
          },
        },
        '& .MuiInputLabel-root': {
          fontSize: '14px',
          lineHeight: '16px',
          color: '#000000',
          top: '50%',
          left: '13px',
          transform: 'translateY(-50%)',
          transformOrigin: 'left top',
          transition: 'all 0.2s ease-out',
          '&.MuiInputLabel-shrink': {
            top: '-8px',
            left: isLongLabel ? '25px' : '28px',
            transform: 'translateY(0)',
            color: '#721FDD',
          },
          '&.Mui-focused': {
            top: '-8px',
            left: isLongLabel ? '25px' : '28px',
            transform: 'translateY(0)',
            color: '#721FDD',
          },
          '&.Mui-error': {
            color: '#FF0000',
          },
        },
        '& legend': {
          padding: '0',
          transition: 'all 0.2s ease',
        },
        '& .MuiOutlinedInput-root.Mui-focused legend, & .MuiInputLabel-shrink ~ .MuiOutlinedInput-root legend':
          {
            padding: '0 8px',
            marginLeft: '10px',
          },
      }}
    />
  );
};

export default LoginInput;
